<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="슥삭" />
            <Navbar>
            </navbar>
            <!-- <Banner></Banner> -->
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container fluid class="px-5" style="min-height:1200px">
                            <v-row class="mt-5">
                                <span class="col-12 rem-2 text-left">후기 현황 - 관리자 전용</span>
                            </v-row>
                            <v-row class="mt-5">
                                <v-tabs v-model="tab" background-color="primary" dark>
                                    <v-tab v-for="item in items" :key="item.tab" v-on:click="goCategory(item.href)">
                                        {{ item.tab }}
                                    </v-tab>
                                </v-tabs>
                            </v-row>

                            <!-- <v-row class="">
                                <v-text-field label="검색어" height="40" outlined hint="검색어를 입력해주세요." class="ml-auto mr-0 col-xs-6 col-sm-4 mt-1" v-model="query" block></v-text-field>
                                <v-btn height="40" class="bg-main text-white mt-3" @click="search(0)"><v-icon>mdi-magnify</v-icon></v-btn>
                            </v-row> -->

                            <v-row v-if="errMsg != null" class="mt-5">
                                <span class="col-12 display-1 text-left">{{errMsg}}</span>
                            </v-row>
                            <v-row v-if="errMsg == null && clubs != null && clubs.length == 0" class="mt-5">
                                <span class="col-12 display-1 text-left">업로드된 후기가 없습니다.</span>
                            </v-row>

                        
                            <v-row class="mt-5">
                                <v-simple-table class="mx-auto">
                                    <thead>
                                        <th>활동명</th>
                                        <th>활동타입</th>
                                        <th>활동학교/지역</th>
                                        <th>카테고리</th>
                                        <th>score0</th>
                                        <th>score1</th>
                                        <th>score2</th>
                                        <th>score3</th>
                                        <th>score4</th>
                                        <th>후기 개수</th>
                                        <th>블로그 개수</th>
                                        <th>최근 업데이트 일자</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="club in clubs" class="pointer-cursor" @click="$router.push(`/admin/clubs/${club.clubIdx}`)">
                                            <td class="text-left">{{club.clubName}}</td>
                                            <td class="text-left">
                                                <span v-if="club.clubType == 0">연합동아리</span>
                                                <span v-else-if="club.clubType == 1">교내동아리</span>
                                                <span v-else-if="club.clubType == 2">대외활동</span>
                                                <span v-else>인턴</span>
                                            </td>
                                            <td class="text-left">{{club.univOrLocation}}</td>
                                            <td class="text-left">{{club.categoryList}}</td>
                                            <td class="text-left">{{String(club.score0sum / club.scoreNum).substr(0, 3)}}</td>
                                            <td class="text-left">{{String(club.score1sum / club.scoreNum).substr(0, 3)}}</td>
                                            <td class="text-left">{{String(club.score2sum / club.scoreNum).substr(0, 3)}}</td>
                                            <td class="text-left">{{String(club.score3sum / club.scoreNum).substr(0, 3)}}</td>
                                            <td class="text-left">{{String(club.score4sum / club.scoreNum).substr(0, 3)}}</td>
                                            <td class="text-left">{{club.scoreNum}}</td>
                                            <td class="text-left">{{club.blogPostNum}}</td>
                                            <td class="text-left">{{club.maxRegDate}}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>

                            </v-row>
                            <v-row v-if="tableInfo" class="mt-5 mb-5">
                                <v-col cols="12" class="text-center">
                                    <v-btn v-if="tableInfo.curSet > 1" class="bg-main text-white mt-1" @click="getSetPageHref(-1)"><v-icon>mdi-chevron-left</v-icon></v-btn>
                                    <v-btn v-for="pageNum in pageList" :class="cur == pageNum ? 'mx-1 mt-1 blue darken-2 text-white' : 'mx-1 mt-1 white text-black'" elevation="5" @click="getPageHref(pageNum)">{{pageNum}}</v-btn>
                                    <v-btn v-if="tableInfo.curSet < tableInfo.totalSet" class="bg-main text-white mt-1" @click="getSetPageHref(1)"><v-icon>mdi-chevron-right</v-icon></v-btn>
                                </v-col>
                                
                            </v-row>
                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
    
            </v-container>
    
    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()

        this.cur = this.$route.query.cur
        this.clubType = this.$route.query.clubType

        if(this.cur == null){
            this.cur = 1
        }

        if(this.clubType == null){
            this.tab = 0
        }
        else{
            this.clubType = Number(this.clubType)
            if(this.clubType == 0 || this.clubType == 1 || this.clubType == 2 || this.clubType == 3){
                this.tab = this.clubType + 1
            }
            else{
                this.tab = 0
                this.clubType = null
            }
        }
        this.getClubs()
        
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 2,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,

            drawer: false,
            group: null,

            tab: null,
            items: [
                { tab: '전체', href:'/admin/clubs'},
                { tab: '연합동아리', href:'/admin/clubs?clubType=0' },
                { tab: '교내동아리', href:'/admin/clubs?clubType=1' },
                { tab: '대외활동', href:'/admin/clubs?clubType=2' },
                { tab: '인턴', href:'/admin/clubs?clubType=3' },
            ],
            clubType: null,
            cur: null,
            clubs: null,
            tableInfo: null,
            errMsg: null,

            cur: 1,
            totalPage: null,
            startPage: null,
            pageList: [],
            query: '',
            adminAcceptDialog: [],

            //searchFirst: false,
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
        goCategory(href){
            window.location.href=href
        },
        getPageHref(page){
            this.cur = page
            this.getClubs()
            // if(this.query == ''){
            //     this.getPosters()
            // }
            // if(this.query.trim().length < 2){
            //     alert('검색어를 두글자 이상 입력해주세요.')
            // }
            // else{
            //     this.search(1)
            // }
        },
        getSetPageHref(next){
            let firstPage = (Math.ceil(this.cur / 10) - 1) * 10 + 1
            let nextPage;
            if(next == -1){
                nextPage = firstPage - 1
            }
            else{
                nextPage = firstPage + 10
            }
            this.cur = nextPage
            this.getClubs()
        },
        getClubs(){
            let queryParam = '?cur=' + this.cur
            if(this.clubType != null){
                queryParam = queryParam + '&clubType=' + this.clubType
            }

            this.$http.get('/api/clubs' + queryParam)
                .then((response) => {
                    console.log(response)
                    if (response.data.status == 200) {
                        this.clubs = response.data.data.clubs
                        this.tableInfo = response.data.data.tableInfo
                        
                        this.pageList = []
                        for(var i = this.tableInfo.startPage; i <= this.tableInfo.endPage; i++){
                            this.pageList.push(i)
                        }
                        this.adminAcceptDialog = []
                        for(var i = 0; i < this.clubs.length; i++){
                            this.adminAcceptDialog.push(false)
                        }
                    }
                    else if(response.data.status == 400){
                        this.errMsg = '로그인을 해주세요.'
                    }
                    else{
                        this.errMsg = '서버 오류'
                    }
                })
        },
        
        adminAcceptClubPost(clubPostIdx, adminType, index){
            this.adminAcceptDialog.splice(index, 1, false)
            let updateAdmin;
            if(adminType == 0){
                updateAdmin = 1
            }
            else{
                updateAdmin = 0
            }
            this.$http.post('/api/clubs/adminAccept/' + clubPostIdx + '?adminType=' + updateAdmin)
            .then( response => {
                if(response.data.status == 204){
                    console.log('승인 성공')
                    this.getClubs()
                } else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch( error => {
                console.log('failed', error)
            })
        },
    }
}
</script>

<style lang="css">

</style>


// WEBPACK FOOTER //
// src/pages/AllClubs.vue